<template>
	<div>
		<div class="btn">
			<RadioGroup v-model="animal">
				<Radio label="列表"></Radio>
				<Radio label="地图"></Radio>
			</RadioGroup>
		</div>
		<div class="lb" v-if="animal=='列表'">
			<div class="query">
				<div class="checkbox">
					<Select v-model="query.macKind" style="width:200px" @on-change="onchange" placeholder="设备分类">
					        <Option value="SHJ" >售货机</Option>
					        <Option value="KFJ" >咖啡机</Option>
					        <Option value="1" >不限</Option>
					</Select>
				</div>
				<Input search enter-button placeholder="请输入地址/名称编号" v-model="query.like" style="width: 500px;" @on-search="onsearch"  />
			</div>

			<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection"  :loading="loading">

				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="aisle(row.id)">货道信息</Button>

				</template>
			</Table>
			<div class="my-page">
				<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>
		<div class="ditu" v-else>
			<ditu :zxd="zxd" :qt="qt"></ditu>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import ditu from '@/components/comm/ditu/ditu.vue'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				animal: '列表',
				//地图
				zxd: [106.49275526969987, 29.61166095192132], //中心点坐标
				qt: [
					/* {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
					{position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'} */
				],
				//地图
				//选中的数据
				selectionData: [],
				//查询条件
				wd: [],
				zt: [],
				gz: [],
				query: {
					page: 0,
					size: 10,
					macKind:''
				},
				//总页数
				total: 100,
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					}, 
					// {
					// 	title: '编号',
					// 	key: 'macCode'
					// },
					{
						title: '设备类型',
						key: 'macDetailsName'
					},
					{
						title: '分类',
						key: 'macKindstString'
					},
					{
						title: '出货口数量',
						key: 'holeType'
					},
					{
						title: '位置',
						key: 'address'
					},
					{
						title: '停用/启用',
						key: 'startUsing',
						render: (h, params) => {
							if (params.row.startUsing == true) {
								return h("div", "启用")
							} else {
								return h("div",{style:{color:'red'}},"停用") 
							}
						}
					},
					{
						title: '是否故障',
						key: 'state',
						render: (h, params) => {
							if (params.row.state == true) {
								return h("div", "正常")
							} else {
								return h("div",{style:{color:'red'}},"故障") 
							}
						}
					},
					{
						title: '状态',
						key: 'macContractStateString',
						render: (h, params) => {
							if (params.row.macContractStateName == 'WC') {
								return h("div", {style:{color:'green'}},params.row.macContractStateString)
							} else if(params.row.macContractStateName == 'YC') {
								return h("div",{style:{color:'red'}},params.row.macContractStateString) 
							} else{
								return h("div",{style:{color:'blue'}},params.row.macContractStateString) 
							}
						}
					},
					{
						title: '商店管理者',
						key: 'facilityEmp',
						render: (h, params) => {
							return h("div", params.row.facilityEmp.name)
						}
					},
					{
						title: '货道总数',
						key: 'total'
					},
					{
						title: '未分配数',
						key: 'isNull'
					},
					{
						title: '已分配数',
						key: 'isNotNull'
					},
					{
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}
				],
				data6: []

			}
		},
		methods: {
			onchange(){
				this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			onsearch(){
				let _this=this
				this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			aisle(id) { //货道商品信息
				this.$router.push({
					name: 'alliance/mac/aisle/list',
					query: {
						id: id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/page/alliance',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macFaultDetailss.totalElements
						_this.data6 = data.macFaultDetailss.content

						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			},
			ajaxPageDitu() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/page/alliance',
					data: {
						page: 0,
						size: 1000,
						macKind:'1'
					},
					_this: _this,
					success: function(data) {
						let a = data.macFaultDetailss.content
						for (var i = 0; i < a.length; i++) {
							let latitude = parseFloat(a[i].latitude)
							let longitude = parseFloat(a[i].longitude)
							let b = {
								position: [longitude, latitude],
								id: a[i].id,
								url: 'mac/aisle/list',
								address: a[i].address,
								code: a[i].macCode,
							}

							_this.qt.push(b)
						}
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			},
			addressDetail() { //获取地理位置 
				var self = this;
				//全局的this在方法中不能使用，需要重新定义一下
				var geolocation = new BMap.Geolocation();
				//调用百度地图api 中的获取当前位置接口
				geolocation.getCurrentPosition(function(r) {
					if (this.getStatus() == BMAP_STATUS_SUCCESS) {
						//获取当前位置经纬度
						var myGeo = new BMap.Geocoder();
						myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), function(result) {
							if (result) {
								//根据当前位置经纬度解析成地址
								self.ADDRESS_DETAIL(result.addressComponents.district + result.addressComponents.street); //在vuex中存入区、街道地址信息。其他地方需要使用直接调用

								self.geohash = result.point.lat + "," + result.point.lng;
								self.SAVE_GEOHASH(self.geohash);

								self.zxd[0] = result.point.lat;
								self.zxd[1] = result.point.lng;
								// console.log(result.point.lat); self.RECORD_ADDRESS({'latitude':result.point.lat,'longitude':result.point.lng});
							}
						});
					}
				});
			},
			selection(data) { //多选按钮发生变化的回调
				this.selectionData = data
			},
			cold() { //设置常温或者冷藏

			},
			start() { //启用或者停用设备
			}

		},
		components: {
			page,
			ditu
		},
		created() {
			this.ajaxPage();
			this.ajaxPageDitu()
			this.addressDetail()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/alliance/mac/list.vue